import React, { useState } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { useTranslation } from 'react-i18next';
import { Notification } from '@/common/utils/index';
import { exportResellersCsv } from '@/entities/admin-resellers/admin-resellers.api';

const ExportButton = ({ search, sortBy, sortOrder }) => {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = async () => {
    try {
      setIsExporting(true);
      const blob = await exportResellersCsv({ search, sortBy, sortOrder });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', 'resellers.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      Notification.error(t('Downloading resellers error'));
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      color="success"
      disabled={isExporting}
      loading={isExporting}
      onClick={handleClick}
      size="medium"
      startIcon={
        isExporting ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <IosShareOutlinedIcon />
        )
      }
      sx={{
        marginLeft: 'auto',
        minWidth: '132px',
        alignSelf: 'center',
        padding: '8px',
      }}
    >
      {isExporting ? t('Exporting...') : t('Export CSV')}
    </Button>
  );
};

export default ExportButton;
